/// <reference path="configs/app-configuration.ts" />
import { Inject, Injectable,InjectionToken } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc'
import { tap } from 'rxjs/operators'
import { APP_CONFIG, AppConfiguration } from './configs/app-configuration'
//import { InternalTokenApiService } from '@app/infrastructure/auth/internal-token/internal-token-api.service'
//import { AppRequestAssistant } from '@app/infrastructure/auth/app-request-assistant'
// export const config = new InjectionToken<any>('APP_SETTINGS');

@Injectable()
export class AuthService {
  private _token$: BehaviorSubject<string> = new BehaviorSubject<string>('')

  constructor(
    @Inject(APP_CONFIG) private appConfiguration: AppConfiguration,

    //private config: AppConfiguration,
    private oAuthService: OAuthService,
    // @Inject(config) private appConfiguration: any
    //private internalTokenApiService: InternalTokenApiService,
    //private appRequestAssistant: AppRequestAssistant,
  ) {
  }

  private updateToken(internalToken: string): void {
    this._token$.next(internalToken)
  }

  public getToken(): string {
    return this._token$.getValue()
  }

  public get token$(): Observable<string> {
    return this._token$.asObservable()
  }

  public init(): Promise<any | undefined> {
    // const authConfig: AuthConfig = {
    //   issuer: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_QumBeYmRn",
    //   tokenEndpoint: "https://m4m-test.auth.us-east-1.amazoncognito.com/oauth2/token",
    //   clientId: "3mdou8ghod7o9ehtkugmiomhmj",
    //   responseType: "code",
    //   scope: "openid email profile",
    //   userinfoEndpoint: "https://m4m-test.auth.us-east-1/oauth2/userInfo",
    //   redirectUri: window.location.origin,
    //   showDebugInformation: true,
    //   strictDiscoveryDocumentValidation: false,
    //   loginUrl:"https://m4m-test.auth.us-east-1.amazoncognito.com/logout?client_id={clientId}&redirect_uri={redirectUri}&response_type={responseType}"
    // }

    this.oAuthService.configure(this.appConfiguration)
    this.oAuthService.setupAutomaticSilentRefresh()

    return (
      this.oAuthService
        .loadDiscoveryDocumentAndTryLogin()
        .then(() => {
          if (this.oAuthService.hasValidAccessToken()) {
            //if (this.config.defaultUser) {
            // // return this.fetchInternalToken().toPromise()
            //}

            this.updateToken(this.oAuthService.getAccessToken())
            localStorage.setItem('cognito.AccessToken', this.oAuthService.getAccessToken());
            window['hotelingDataToken'] = localStorage.getItem("cognito.AccessToken");
            return this.oAuthService.getAccessToken()
          }
          this.oAuthService.initImplicitFlow()
        })
    )
  }

  //private fetchInternalToken(): Observable<any> {
  //  return this.internalTokenApiService.get(this.oAuthService.getAccessToken()).pipe(
  //    tap((internalToken: any) => {
  //      this.appRequestAssistant.updatePrefix('InternalJwt')
  //      this.updateToken(internalToken.userToken)
  //      // @Todo: verify usage
  //      sessionStorage.setItem('internal-token', internalToken.userToken)
  //    }),
  //  )
  //}
}
